import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-white rounded-lg shadow-md p-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-12"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  ref: "tableContainer",
  class: "overflow-auto",
  style: {"max-height":"400px","border":"1px solid #e5e7eb","border-radius":"0.375rem"}
}
const _hoisted_5 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_6 = { class: "bg-gray-50 sticky top-0 z-10" }
const _hoisted_7 = {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_8 = { class: "text-xs font-normal text-gray-400 ml-2 lowercase" }
const _hoisted_9 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["data-id"]
const _hoisted_13 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "flex-shrink-0 h-10 w-10" }
const _hoisted_16 = ["src", "alt"]
const _hoisted_17 = {
  key: 1,
  class: "h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center"
}
const _hoisted_18 = { class: "text-sm font-medium text-gray-700" }
const _hoisted_19 = { class: "ml-4" }
const _hoisted_20 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_21 = { class: "text-sm text-gray-500" }
const _hoisted_22 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_24 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_25 = { class: "px-6 py-4 whitespace-nowrap text-sm font-medium" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "mt-8 bg-gray-50 p-6 rounded-md"
}
const _hoisted_28 = {
  key: 0,
  class: "mb-6 p-4 bg-white rounded-md border"
}
const _hoisted_29 = { class: "flex items-center" }
const _hoisted_30 = { class: "flex-shrink-0 h-12 w-12" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = {
  key: 1,
  class: "h-12 w-12 rounded-full bg-gray-200 flex items-center justify-center"
}
const _hoisted_33 = { class: "text-lg font-medium text-gray-700" }
const _hoisted_34 = { class: "ml-4" }
const _hoisted_35 = { class: "text-lg font-medium text-gray-900" }
const _hoisted_36 = { class: "text-sm text-gray-500" }
const _hoisted_37 = { class: "mb-6" }
const _hoisted_38 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_39 = ["value"]
const _hoisted_40 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_41 = ["value"]
const _hoisted_42 = {
  key: 0,
  class: "mt-1 text-sm text-red-500"
}
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "mt-6 flex justify-between items-center" }
const _hoisted_45 = { class: "flex space-x-3" }
const _hoisted_46 = ["disabled", "title"]
const _hoisted_47 = { class: "mt-8 flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isAdmin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"bg-red-50 rounded-full p-6 mb-4\" data-v-5845bffa><svg class=\"h-16 w-16 text-red-500\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" data-v-5845bffa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z\" data-v-5845bffa></path></svg></div><h3 class=\"text-xl font-medium mb-2 text-center\" data-v-5845bffa>Access Denied</h3><p class=\"text-gray-500 mb-6 text-center max-w-md\" data-v-5845bffa> You need Administrator privileges to access User Role Management. Please contact your system administrator if you believe you should have access to this feature. </p>", 3)),
          _createVNode(_component_router_link, {
            to: "/administration",
            class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 inline-block"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Return to Administration ")
            ])),
            _: 1,
            __: [5]
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "mb-6" }, [
            _createElementVNode("h3", { class: "text-xl font-medium mb-2" }, "User Role Management"),
            _createElementVNode("p", { class: "text-gray-500 mb-4" }, " Manage user roles and permissions across the system. You can edit user business roles, system roles, and report types. ")
          ], -1)),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _createElementVNode("thead", _hoisted_6, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_7, [
                      _cache[7] || (_cache[7] = _createTextVNode(" User ")),
                      _createElementVNode("span", _hoisted_8, " (" + _toDisplayString(_ctx.profiles.length) + " users) ", 1)
                    ]),
                    _cache[8] || (_cache[8] = _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Business Role", -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "System Role", -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Report Type", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("th", {
                      scope: "col",
                      class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    }, "Actions", -1))
                  ])
                ]),
                _createElementVNode("tbody", _hoisted_9, [
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, _cache[12] || (_cache[12] = [
                        _createElementVNode("td", {
                          colspan: "5",
                          class: "px-6 py-4 text-center text-gray-500"
                        }, " Loading user profiles... ", -1)
                      ])))
                    : (_ctx.profiles.length === 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_11, _cache[13] || (_cache[13] = [
                          _createElementVNode("td", {
                            colspan: "5",
                            class: "px-6 py-4 text-center text-gray-500"
                          }, " No user profiles found. ", -1)
                        ])))
                      : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profiles, (profile, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: "hover:bg-gray-50 transition-colors duration-300",
                      "data-id": profile.id
                    }, [
                      _createElementVNode("td", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            (profile.avatar_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "h-10 w-10 rounded-full object-cover",
                                  src: profile.avatar_url,
                                  alt: profile.name
                                }, null, 8, _hoisted_16))
                              : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getInitials(profile.name)), 1)
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(profile.name || 'No name'), 1),
                            _createElementVNode("div", _hoisted_21, _toDisplayString(profile.email || 'No email'), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 inline-flex text-xs leading-5 font-semibold rounded-full", _ctx.getBusinessRoleBadgeClass(profile.business_role)])
                        }, _toDisplayString(_ctx.formatBusinessRole(profile.business_role)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_23, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["px-2 inline-flex text-xs leading-5 font-semibold rounded-full", _ctx.getSystemRoleBadgeClass(profile.system_role)])
                        }, _toDisplayString(_ctx.formatSystemRole(profile.system_role)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(profile.report_type || 'Not assigned'), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.editProfile(profile)),
                          class: "text-indigo-600 hover:text-indigo-900"
                        }, "Edit", 8, _hoisted_26)
                      ])
                    ], 8, _hoisted_12))
                  }), 128))
                ])
              ])
            ], 512)
          ]),
          (_ctx.isEditing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[21] || (_cache[21] = _createElementVNode("h4", { class: "text-lg font-medium mb-4" }, "Edit User Profile", -1)),
                _createElementVNode("form", {
                  onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveProfile && _ctx.saveProfile(...args)), ["prevent"]))
                }, [
                  (_ctx.editingProfile)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            (_ctx.editingProfile.avatar_url)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "h-12 w-12 rounded-full object-cover",
                                  src: _ctx.editingProfile.avatar_url,
                                  alt: _ctx.editingProfile.name
                                }, null, 8, _hoisted_31))
                              : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.getInitials(_ctx.editingProfile.name)), 1)
                                ]))
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.editingProfile.name || 'No name'), 1),
                            _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.editingProfile.email || 'No email'), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", null, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", {
                          for: "business_role",
                          class: "block text-sm font-medium text-gray-700"
                        }, [
                          _createTextVNode(" Business Role "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "business_role",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.business_role) = $event)),
                          class: _normalizeClass(["mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md", {'border-red-300 focus:ring-red-500 focus:border-red-500': !_ctx.formData.business_role && _ctx.formTouched}]),
                          required: ""
                        }, [
                          _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "Select a business role", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessRoleOptions, (role) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: role,
                              value: role
                            }, _toDisplayString(_ctx.formatBusinessRole(role)), 9, _hoisted_39))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, _ctx.formData.business_role]
                        ]),
                        (!_ctx.formData.business_role && _ctx.formTouched)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_40, " Business Role is required "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[17] || (_cache[17] = _createElementVNode("label", {
                          for: "system_role",
                          class: "block text-sm font-medium text-gray-700"
                        }, [
                          _createTextVNode(" System Role "),
                          _createElementVNode("span", { class: "text-red-500" }, "*")
                        ], -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "system_role",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.system_role) = $event)),
                          class: _normalizeClass(["mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md", {'border-red-300 focus:ring-red-500 focus:border-red-500': !_ctx.formData.system_role && _ctx.formTouched}]),
                          required: ""
                        }, [
                          _cache[16] || (_cache[16] = _createElementVNode("option", { value: "" }, "Select a system role", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemRoleOptions, (role) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: role,
                              value: role
                            }, _toDisplayString(_ctx.formatSystemRole(role)), 9, _hoisted_41))
                          }), 128))
                        ], 2), [
                          [_vModelSelect, _ctx.formData.system_role]
                        ]),
                        (!_ctx.formData.system_role && _ctx.formTouched)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_42, " System Role is required "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[19] || (_cache[19] = _createElementVNode("label", {
                          for: "report_type",
                          class: "block text-sm font-medium text-gray-700"
                        }, "Report Type", -1)),
                        _withDirectives(_createElementVNode("select", {
                          id: "report_type",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.report_type) = $event)),
                          class: "mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                        }, [
                          _cache[18] || (_cache[18] = _createElementVNode("option", { value: "" }, "Not assigned", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTypeOptions, (type) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: type,
                              value: type
                            }, _toDisplayString(type), 9, _hoisted_43))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, _ctx.formData.report_type]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _cache[20] || (_cache[20] = _createElementVNode("p", { class: "text-sm text-gray-500" }, [
                      _createTextVNode("Fields marked with "),
                      _createElementVNode("span", { class: "text-red-500" }, "*"),
                      _createTextVNode(" are required")
                    ], -1)),
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args))),
                        class: "px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      }, " Cancel "),
                      _createElementVNode("button", {
                        type: "submit",
                        class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                        disabled: !_ctx.isFormValid,
                        title: !_ctx.isFormValid ? 'Please fill in all required fields' : ''
                      }, " Update Profile ", 8, _hoisted_46)
                    ])
                  ])
                ], 32)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_router_link, {
              to: "/administration",
              class: "px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 inline-block"
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode(" Return to Administration ")
              ])),
              _: 1,
              __: [22]
            })
          ])
        ]))
  ]))
}